import React, { ReactNode, useContext } from 'react';
import {
  GestureResponderEvent,
  StyleSheet,
  TouchableHighlight,
} from 'react-native';

import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({
  children,
  onClick,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  size,
}: {
  children: ReactNode;
  onClick?: (ev: GestureResponderEvent) => {};
  size?: 'lg' | 'md' | 'sm' | 'xl';
}) {
  const { storeStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  const styles = StyleSheet.create({
    button: {
      padding: 8,
      borderRadius: 4,
      margin: 4,
      backgroundColor: colors.background[800],
    },
  });
  return (
    <TouchableHighlight
      underlayColor={colors.background[800]}
      style={styles.button}
      onPress={onClick}
    >
      {children}
    </TouchableHighlight>
  );
}
